import { useLocation } from "react-router";
import PreloaderList from "../Preloader/List";
import { usePersistedState } from "../../../context/PersistedStateProvider";
import { isArrayItems } from "../../../utils";
import FeatureGroup from "./FeatureGroup";

export default function NavBarView({ features }) {
  const {
    custom_projects: {
      defaultCustomProject,
      permittedCustomProjects,
      audienceVariables,
      variables,
      audiences,
    } = {},
  } = usePersistedState();

  const location = useLocation();
  return (
    <nav>
      {features && isArrayItems(features) ? (
        features.map(([key, value], index) => {
          let hasChildren =
            Array.isArray(value.items) && value.items.length > 0;
          let overrideActive = value?.defaultActive;
          let isActive = false;

          let all_feature_urls = value.items?.map((item) => item.path);

          let hasSelectMenu = value?.hasSelectMenu;
          let { pathname } = location || {};

          if (value.path === "/" && pathname === "/") {
            isActive = true;
          } else {
            if (value.path !== "/" && all_feature_urls?.includes(pathname))
              isActive = true;
          }

          if (hasChildren) {
            isActive = value.items.some(
              (item) => value.path !== "/" && pathname.startsWith(item.path)
            );
          }

          if (overrideActive) isActive = true;

          return (
            <FeatureGroup
              isActive={isActive}
              key={index}
              feature_name={key}
              feature_items={value}
              hasSelectMenu={hasSelectMenu}
              pathname={pathname}
              hasChildren={hasChildren}
              defaultCustomProject={defaultCustomProject}
              permittedCustomProjects={permittedCustomProjects}
              audienceVariables={audienceVariables}
              variables={variables}
              audiences={audiences}
            />
          );
        })
      ) : (
        <PreloaderList itemCount={10} />
      )}
    </nav>
  );
}
